<template>
  <div class="zoom">
    <img :src="src" :alt="alt" refs="zoom" />
  </div>
</template>

<script>
require('jquery-zoom');

export default {
  name: 'DefZoom',
  props: ['alt', 'src'],
  beforeUpdate() {
    this.destroy();
  },
  updated() {
    this.init();
  },
  mounted() {
    this.init();
  },
  beforeUnmount() {
    this.destroy();
  },
  methods: {
    init() {
      $(this.$el).zoom({
        url: this.src,
        on: 'click',
        magnify: 1.2,
      });
    },
    destroy() {
      $(this.$el).trigger('zoom.destroy');
    },
  },
};
</script>

<style>
.zoom {
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.zoom:after {
  content: '';
  display: block;
  width: 33px;
  height: 33px;
  position: absolute;
  top: 0;
  right: 0;
  background: url(https://raw.github.com/jackmoore/zoom/master/icon.png);
}

.zoom img {
  display: block;
  max-width: 100%;
}

.zoom img::-moz-selection {
  background-color: transparent;
}

.zoom img::selection {
  background-color: transparent;
}
</style>
